export const QUOTE_PERMISSIONS = {
  isHidden: 'isHidden',
  isProposalReadonly: 'isProposalReadonly',
  isQuoteReadonly: 'isQuoteReadonly',
  canUpdateProposal: 'allowProposalUpdate',
  canSubmitProposal: 'allowProposalSubmit',
  canReturnProposal: 'allowReturn',
  canSendRenewalInvite: 'allowSendRenewalInvite',
  canUpdateAdjustment: 'allowQuoteAdjustmentUpdate',
  canUpdateEndorsements: 'allowQuoteEndorsementUpdate',
  canUpdateAddons: 'allowAddonUpdate',
  canUpdateOptions: 'allowOptionUpdate',
  canSendQuote: 'allowQuoteSend',
  canAcceptQuote: 'allowQuoteAccept',
  canPay: 'allowPayment',
  canPayByPremiumFinance: 'allowPremiumFinance',
} as const;

export type QuotePermissionKey =
  (typeof QUOTE_PERMISSIONS)[keyof typeof QUOTE_PERMISSIONS];

export type QuotePermission = {
  key: QuotePermissionKey;
  value: boolean;
};

export type QuotePermissions = QuotePermission[];
